import * as React from 'react';

import {BreakdownPreviewProps} from 'common/onboarding/immersive-onboarding/types';
import {PROPERTY_BREAKDOWN_MAP} from 'common/onboarding/immersive-onboarding/constants';
import {AnalysisType, ChartPlotStyle, DisplayOptions} from 'common/report/insights/util/types';
import {ChartType, ValueRepresentationType} from 'common/report/constants';

import {CardSnabbdom} from '../chart-card';

const SERIES = [
  {
    $overall: {all: 45244},
    a: {all: 44781},
    b: {all: 4391},
  },
  {$overall: {all: 22550}, a: {all: 22478}, b: {all: 79}},
  {
    $overall: {all: 25008},
    a: {all: 24880},
    b: {all: 2320},
  },
  {
    $overall: {all: 21522},
    a: {all: 21471},
    b: {all: 912},
  },
];

const getSeries = (events: string[], property) => {
  return events.reduce((data, event, index) => {
    data[event] = SERIES[index];
    data[event][PROPERTY_BREAKDOWN_MAP[property][0]] = data[event].a;
    data[event][PROPERTY_BREAKDOWN_MAP[property][1]] = data[event].b;
    return data;
  }, {});
};

const props = (events, property) => {
  const displayOptions: DisplayOptions = {
    chartType: ChartType.Bar,
    plotStyle: ChartPlotStyle.Standard,
    analysis: AnalysisType.Linear,
    value: ValueRepresentationType.Absolute,
    funnelStepsSelectedTableColumns: null,
  };
  return {
    cardTitle: `How many users performed each action?`,
    chartOptions: {type: `bar`},
    bookmark: {
      type: `insights`,
      original_type: `insights`,
      name: `How many users performed each action?`,
      metadata: null,
      dashboard: {},
      params: {
        sections: {
          cohorts: [],
          filter: [],
          formula: [],
          group: [
            {
              dataset: `$mixpanel`,
              value: `$os`,
              resourceType: `events`,
              profileType: null,
              search: ``,
              dataGroupId: null,
              propertyType: `string`,
              typeCast: null,
              unit: null,
              customGroups: [{filterOperator: `equals`, filterValue: [`Android`, `iOS`]}],
            },
          ],
          show: events.map((event) => ({
            behavior: {
              type: `event`,
              resourceType: `events`,
              name: event,
              search: ``,
              profileType: null,
              filters: [],
              dataGroupId: null,
              dataset: `$mixpanel`,
            },
            measurement: {math: `unique`, property: null, cumulative: false, perUserAggregation: null, rolling: null},
          })),
          time: [{unit: `day`, value: 30}],
        },
        columnWidths: {bar: {}},
        displayOptions,
        sorting: {
          bar: {
            sortBy: `column`,
            colSortAttrs: [
              {sortBy: `value`, sortOrder: `desc`},
              {sortBy: `value`, sortOrder: `desc`},
            ],
          },
          line: {
            sortBy: `column`,
            colSortAttrs: [
              {sortBy: `value`, sortOrder: `desc`, valueField: `averageValue`},
              {sortBy: `value`, sortOrder: `desc`, valueField: `averageValue`},
            ],
          },
          table: {
            sortBy: `value`,
            sortOrder: `desc`,
            valueField: `totalValue`,
            viewNLimit: 12,
            colSortAttrs: [{sortBy: `value`, sortOrder: `desc`, valueField: `totalValue`, viewNLimit: 12}],
          },
          'insights-metric': {
            sortBy: `column`,
            colSortAttrs: [
              {sortBy: `value`, sortOrder: `desc`, valueField: `totalValue`},
              {sortBy: `value`, sortOrder: `desc`, valueField: `totalValue`},
            ],
          },
          pie: {
            sortBy: `column`,
            colSortAttrs: [
              {sortBy: `value`, sortOrder: `desc`, valueField: `totalValue`},
              {sortBy: `value`, sortOrder: `desc`, valueField: `totalValue`},
            ],
          },
          'retention-curve': {
            sortBy: `value`,
            sortOrder: `desc`,
            valueField: `size`,
            colSortAttrs: [
              {sortBy: `value`, sortOrder: `desc`, valueField: `size`},
              {sortBy: `value`, sortOrder: `desc`, valueField: `size`},
            ],
          },
        },
        legend: {
          filteredBreakdownSegments: [
            {
              selected: events.map((event) => ({key: event})),
            },
            {selected: PROPERTY_BREAKDOWN_MAP[property].map((prop) => ({key: prop}))},
          ],
        },
      },
    },
    chartParams: {
      computed_at: `2023-11-21T14:29:05.403551+00:00`,
      headers: [`$event`, property],
      date_range: {from_date: `2023-10-22T00:00:00-07:00`, to_date: `2023-11-21T06:33:57.493503-08:00`},
      meta: {
        min_sampling_factor: 1,
        time_period_settings: {quarter_start_month: 1},
        report_sections: {
          group: [],
          show: events.map((event) => ({metric_key: event})),
        },
      },
      series: getSeries(events, property),
    },
    dataGroups: null,
  };
};

export const BarBreakdownPreview = ({events, property}: BreakdownPreviewProps) => {
  //@ts-ignore
  return <CardSnabbdom params={props(events, property)} />;
};
